import React from 'react'

import Thumbnail from './thumbnail'
import CampusreelThumbnail from './campusreelThumbnail'
import InstagramThumbnail from '../../InstagramThumbnail'
import injectSheet from 'react-jss'

import { NETWORK_TYPES } from 'aria-viewer/tour/constants'
import ThumbPhoto from 'public/assets/svg/thumb_photo.svg'
import ThumbVideo from 'public/assets/svg/thumb_video.svg'
import ThumbPano from 'public/assets/svg/thumb_pano.svg'
import MoreMedia from 'public/assets/svg/more_media.svg'

function numberofMedias(photos, panos, videos) {
    let count = 0
    if (photos?.length > 0) count++
    if (panos?.length > 0) count++
    if (videos?.length > 0) count++

    return count
}

const style = theme => ({
    toolTip: {
        position: 'absolute',
        zIndex: '1',
        top: '-65%',
        transform: ({ hover, photos, panoramas, videos }) => {
            return hover && numberofMedias(photos, panoramas, videos) > 1 ? 'translateX(-100%)' : 'translateX(0%)'
        },
        width: 155,
        backgroundColor: '#08131E',
        color: '#fff',
        textAlign: 'center',
        borderRadius: '8px',
        padding: '5px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '23px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '50%',
            marginLeft: '-10px',
            borderWidth: '8px',
            borderStyle: 'solid',
            borderColor: 'black transparent transparent transparent',
        },
    },

    container: {
        position: 'relative',
        height: '84px',
        width: '132px',
        transform: ({ isDescriptionVisible }) => (isDescriptionVisible ? 'translateX(-150px)' : 'translateX(0px)'),
        '& div': {
            width: '128px',
            height: '80px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
            border: 'solid 2px #ffffff',
            borderRadius: '8px',
            transition: 'transform ease-in-out 0.5s',
            position: 'absolute',
            cursor: 'pointer',
        },
        '& div:nth-child(1)': {
            transform: ({ hover, photos, panoramas, videos }) => {
                if (numberofMedias(photos, panoramas, videos) > 1)
                    return !hover ? 'translate(14px, 14px) scale(1)' : 'translate(2px, 2px) scale(1.2)'
            },
            zIndex: 100,
        },
        '& div:nth-child(2)': {
            transform: ({ hover }) => (!hover ? 'translate(7px, 7px) scale(1)' : 'translate(-162px, 2px) scale(1.2)'),
            zIndex: 200,
        },
        '& div:nth-child(3)': {
            transform: ({ hover }) => (!hover ? 'translate(-2px, -2px) scale(1)' : 'translate(-327px, 2px) scale(1.2)'),
            zIndex: 300,
        },
    },
})

const SupplementalMediaButton = ({
    classes,
    hover,
    photos,
    panoramas,
    videos,
    photoThumbnailUrl,
    onPanoThumbnailClick,
    onVideoThumbnailClick,
    onPhotoThumbnailClick,
    onMouseEnter,
    onMouseLeave,
}) => (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={classes.container}>
        {panoramas.length > 0 && (
            <Thumbnail
                url={panoramas[0].thumburl || panoramas[0].urls?.tiny}
                count={panoramas.length}
                hover={hover}
                img={ThumbPano}
                thumbClick={onPanoThumbnailClick}
            />
        )}
        {videos.length > 0 &&
            (video => {
                if (video.network === NETWORK_TYPES.instagram)
                    return (
                        <InstagramThumbnail
                            embedId={video.videoid}
                            width={128}
                            height={80}
                            top={-54}
                            left={-50}
                            iframeHeight={'170%'}
                            iframeWidth={'180%'}
                            onClick={onVideoThumbnailClick}
                            count={videos.length}
                            hover={hover}
                            img={ThumbVideo}
                        />
                    )
                if (video.type === 'campusreel')
                    return (
                        <CampusreelThumbnail
                            embedId={video.url}
                            width={128}
                            height={80}
                            top={-25}
                            left={-50}
                            iframeHeight={'170%'}
                            iframeWidth={'180%'}
                            onClick={onVideoThumbnailClick}
                            count={videos.length}
                            hover={hover}
                            img={ThumbVideo}
                        />
                    )
                return (
                    <Thumbnail
                        url={video.thumburl || video.urls?.tiny}
                        count={videos.length}
                        hover={hover}
                        img={ThumbVideo}
                        thumbClick={onVideoThumbnailClick}
                    />
                )
            })(videos[0])}
        {photos.length > 0 &&
            (photo => {
                if (photo.network === NETWORK_TYPES.instagram)
                    return (
                        <InstagramThumbnail
                            embedId={photo.url}
                            width={128}
                            height={80}
                            top={-54}
                            left={0}
                            iframeHeight={'170%'}
                            onClick={onPhotoThumbnailClick}
                            count={photos.length}
                            hover={hover}
                            img={ThumbPhoto}
                        />
                    )
                return (
                    <Thumbnail
                        url={photoThumbnailUrl}
                        count={photos.length}
                        hover={hover}
                        img={ThumbPhoto}
                        thumbClick={onPhotoThumbnailClick}
                    />
                )
            })(photos[0])}
        {hover && (
            <span className={classes.toolTip}>
                <img src={MoreMedia}></img>
                <span>Media Galleries</span>
            </span>
        )}
    </div>
)

SupplementalMediaButton.defaultProps = {
    onPanoThumbnailClick: () => {},
    onVideoThumbnailClick: () => {},
    onPhotoThumbnailClick: () => {},
    onMouseEnter: () => {},
    onMouseLeave: () => {},
}

export default injectSheet(style)(SupplementalMediaButton)
